"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ShowMenu;

var _ShowMenu = require("@adobe/react-spectrum-workflow/dist/ShowMenu");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ShowMenu(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_ShowMenu.A4uShowMenu, null));
}